export default {
    isFetching: false,
    isOpen: false,
    isGlobalOpen: false,
    toast: null,
    chat: {},
    messages: [],
};
